import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import QRCodeGenerator from "../../QrCode/QrCodeGenerator";
import homeblackicon from "../../Assets/Images/home-black.svg";
import apple from "../../Assets/Images/apple.svg";
import google from "../../Assets/Images/google.svg";
import downloadIcon from "../../Assets/Images/downloadIcon.svg";
import pdfIcon from "../../Assets/Images/pdficon.svg";

import Logo from "../../Assets/IconSVG/SolidarityLogo.svg";
import { doc, onSnapshot } from "firebase/firestore";
import db from "../../FireBase/firebaseConfig";

const PolicyDocs = () => {
  //const [documentId, setReqId] = useState("d7604bf4-bf9e-4803-7b8f-08dd4f59d624");
  const [payment, setPayment] = useState(null); // State to hold the filtered payment data
  const [loading, setLoading] = useState(true); // Loading state
  const [error, setError] = useState(null); // State to hold any errors
  const [documents, setDocuments] = useState([]);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const policy = queryParams.get("policy");

  const documentId = queryParams.get("id");

  const [ViewLoading, setViewLoading] = useState(false);
  const [shortLink, setShortLink] = useState("");

  const GenerateLink = async () => {
    setViewLoading(true);
    const url = process.env.REACT_APP_PAYMENT_API + "Requests/GenerateLink";
    const data = {
      id: documentId,
    };

    try {
      //setLoading(true);
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        setViewLoading(false);
        throw new Error("Failed to fetch payment requests");
      }

      const result = await response.json();
      window.location.href = result.link;
      setShortLink(result.link);
      setViewLoading(false);
      return result;
    } catch (error) {
      setViewLoading(false);
      console.error("Error fetching payment requests:", error);
    }
  };

  useEffect(() => {
    const docRef = doc(db, "payment_results", documentId); // "payment_result" is your collection name

    // Using onSnapshot for real-time updates
    const unsubscribe = onSnapshot(
      docRef,
      (docSnap) => {
        setLoading(true); // Start loading
        if (docSnap.exists()) {
          console.log("Document data:", docSnap.data()); // Log the document data
          setPayment(docSnap.data()); // Set payment data from Firestore
        } else {
          console.log("No document found with the given ID");
          setPayment(null); // Set payment to null if no document is found
        }
        setLoading(false); // End loading
      },
      (error) => {
        console.error("Error fetching payment: ", error);
        setError(error.message); // Set error message
        setLoading(false); // End loading
      }
    );

    // Cleanup the listener on component unmount
    return () => {
      unsubscribe();
    };
  }, [documentId]);

  useEffect(() => {
    const abortController = new AbortController();

    if (payment?.ApprovalResult === "Approved") {
      if (policy.startsWith("C/")) {
        GetClaimDocs(abortController.signal);
      } else {
        GetDocs(abortController.signal);
      }
    }

    return () => {
      abortController.abort();
    };
  }, [payment]);
  //process.env.REACT_APP_WEB_API
  const GetDocs = async (signal) => {
    const url = process.env.REACT_APP_WEB_API + "policy/ViewIssuedQuoteDocs";
    const data = {
      quote: policy,
    };

    try {

      setLoading(true);
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
        signal: signal,
      });

      if (!response.ok) {
        throw new Error("Failed to fetch payment requests");
      }

      const result = await response.json();

   const filteredDocs = result
  .filter(d =>
    ["tax invoice", "generate certificate", "policy schedule", "medical certificate"]
      .includes(String(d.ID).toLowerCase())
  )
  .reduce((acc, doc) => {
    const id = String(doc.ID).toLowerCase();
    const existing = acc.find(d => String(d.ID).toLowerCase() === id);

    if (!existing) {
      acc.push(doc); // first time, just add
    } else if (!existing.url && doc.url) {
      // replace if existing has no url but this one does
      const index = acc.indexOf(existing);
      acc[index] = doc;
    }
    return acc;
  }, []);

      setDocuments(filteredDocs);
      setLoading(false);
      return result;
    } catch (error) {
      if (error.name === 'AbortError') {
        console.log('ViewIssuedQuoteDocs request was cancelled');
        return;
      }
      setLoading(false);
      console.error("Error fetching payment requests:", error);
    }
  };

  const GetClaimDocs = async (signal) => {
    const url = process.env.REACT_APP_WEB_API + "claim/GetClaimDocuments";
    const data = {
      ClaimNumber: policy,
    };

    try {
      setLoading(true);
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
        signal: signal,
      });

      if (!response.ok) {
        throw new Error("Failed to fetch payment requests");
      }

      const result = await response.json();

      const filteredDocs = result.filter(
  (doc) => doc.ID === "CLAIM TAX INVOICE"
);
      setDocuments(filteredDocs);
      setLoading(false);
      return result;
    } catch (error) {
      if (error.name === 'AbortError') {
        console.log('GetClaimDocuments request was cancelled');
        return;
      }
      setLoading(false);
      console.error("Error fetching payment requests:", error);
    }
  };

  const handleNavigate = () => {
    //Navigate(process.env.REACT_APP_PAYMENT_API); // This will navigate to /my-policy
    // Open in a new tab
    window.open(process.env.REACT_APP_PORTAL_LINK, "_blank");
  };

  const handleDownload = (fileName, fileUrl) => {
    if (documents[0].File) {
      // Create an anchor element
      const link = document.createElement("a");

      // Set the href to the file URL
      link.href = fileUrl;

      // Set the target to _blank to open in a new tab
      link.target = "_blank";

      // Append the link to the body (required for Firefox)
      document.body.appendChild(link);

      // Programmatically click the link to open the file in a new tab
      link.click();

      // Remove the link from the document
      document.body.removeChild(link);
    }
  };

  if (payment && payment.PaymentStatus === "CAPTURED") {
    return (
      <div className="flex justify-center items-center ">
        <div className="p-8 mt-[5%] mx-auto bg-[#F6F8F9] rounded-[26px] max767:pt-8 max767:mt-0 max767:p-5 max767:w-[100%] max767:rounded-none ipad:w-[95%] ipad:mt-[10%]">
          <div className="">
            <div className="flex justify-between">
              <div className="flex justify-between w-full max767:grid">
                <h1 className="text-[#1A2024] text-2xl not-italic font-semibold leading-8 tracking-[-0.24px] max767:w-full  max767:order-2">
                  Congratulations! You are all done.
                </h1>
                <img
                  src={Logo}
                  alt="Solidarity Logo"
                  className="h-10 max767:flex max767:order-1 max767:mb-2"
                />
              </div>
            </div>
            <p className="mt-10 flex-col text-[#5B6871] text-base not-italic font-normal leading-6 tracking-[-0.16px] w-[65%] max767:w-full max767:mt-4">
              You should have received a notification confirming that your
              insurance plan has been approved with Solidarity
            </p>
          </div>
          <div className="space-y-4">
            {(payment && payment.ApprovalResult === "") ||
            (payment && payment.ApprovalResult === "Approved" && loading) ? (
              <div className="policiesGrid flex w-full items-start content-start gap-4 flex-wrap">
                <div className="policy_card_root cursor-pointer bg-white rounded-2xl w-full h-[207px] flex items-center justify-center">
                  <p className="animate-pulse text-gray-600 text-base font-medium">
                    Please Wait...
                  </p>
                </div>
              </div>
            ) : payment && payment.ApprovalResult == "Approved" ? (
              <div>
                <p className="mt-10 text-[#5B6871] text-base not-italic font-normal leading-6 tracking-[-0.16px] max767:mt-4">
                  View & download your insurance plan documents:
                </p>
                {documents.map((doc, index) => (
                  <div
                    key={index}
                    className="flex items-center justify-between"
                  >
                    <div className="flex items-center space-x-4 w-full">
                      <div className="flex items-center justify-center h-20 w-20">
                        <QRCodeGenerator value={doc?.File} />
                      </div>
                      <div className="flex downloadbtn w-[86%]">
                        <button
                          onClick={() =>
                            handleDownload(doc?.fileName, doc?.File || doc?.url)
                          }
                          className="border bg-white w-full p-4 rounded-lg inline-flex justify-between"
                        >
                          <div className="flex gap-4 text-[#252C32] text-sm not-italic font-semibold leading-6 tracking-[-0.084px]">
                            <img src={pdfIcon} alt="Beneficiary" />
                            <div className="flex flex-col items-start">
                              <span className="text-[#252C32] text-sm not-italic font-semibold leading-6 tracking-[-0.084px] max767:text-left">
                                {doc?.ID}
                              </span>
                              <span className="text-[#84919A] text-xs not-italic font-normal leading-4">
                                {doc?.fileData?.size}
                              </span>
                            </div>
                          </div>
                          <img src={downloadIcon} alt="Download" className="" />
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : payment && payment.ApprovalResult === "DECLINED" ? (
              <div className="policiesGrid flex w-full items-start content-start gap-4 flex-wrap">
                <div className="policy_card_root cursor-pointer bg-white rounded-2xl w-full h-[207px]">
                  DECLINED
                </div>
              </div>
            ) : (
              <div className="policiesGrid flex w-full items-start content-start gap-4 flex-wrap">
                <div className="policy_card_root cursor-pointer bg-white rounded-2xl w-full h-[207px]"></div>
              </div>
            )}
          </div>

          <div className="flex space-x-4 mt-9">
            <p className="text-[#5B6871] text-sm not-italic font-normal leading-5 ">
              For any inquiries you may contact our chatbot via{" "}
              <a
                href="https://api.whatsapp.com/send/?phone=97317130000&text&type=phone_number&app_absent=0"
                className="text-[#5B6871] text-sm not-italic font-medium leading-[150%] underline"
              >
                WhatsApp
              </a>{" "}
              or call us at{" "}
              <a
                href="tel:17130000"
                className="text-[#5B6871] text-sm not-italic font-medium leading-[150%] underline"
              >
                17130000
              </a>{" "}
            </p>
          </div>
          <div className="mt-8 text-center items-center flex gap-2 max767:inline-block max767:w-full">
            <button
              className="flex w-[30%] px-[9px] bg-[#55C6EF] mr-2 rounded-[10px] py-2 items-center gap-2 mb-0 text-[#1A2024] text-sm not-italic font-semibold leading-6 tracking-[-0.084px] max767:w-full ipad:w-[35%]"
              onClick={handleNavigate}
            >
              <p className="items-center text-sm justify-around w-full flex">
                View Your Plan Details
                <img src={homeblackicon} alt="home Icon" className="h-8 flex" />
              </p>
            </button>
            <span className="max767:invisible">OR</span>
            <div className="flex justify-center space-x-4 ml-2">
              <button className="flex gap-1">
                <img
                  src={apple}
                  onClick={() => {
                    window.open(
                      "https://apps.apple.com/bh/app/solidarity/id1585138622",
                      "_blank"
                    );
                  }}
                  alt="app store"
                  className="h-10"
                />
                <img
                  src={google}
                  onClick={() => {
                    window.open(
                      "https://play.google.com/store/apps/details?id=bh.solidarity.app&hl=en&gl=US",
                      "_blank"
                    );
                  }}
                  alt="Google Play"
                  className="h-10"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  } else if (payment && payment.PaymentStatus === "ABANDONED") {
    return (
      <>
        <main className="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
          <div className="text-center">
            <div className="flex justify-center">
              <img src={Logo} alt="Solidarity Logo" className="h-10 mb-4" />
            </div>

            <h1 className="mt-4 text-balance text-5xl font-semibold tracking-tight text-red-600 sm:text-7xl">
              Payment Abandoned
            </h1>

            <p className="mt-6 text-pretty text-lg font-medium text-gray-500 sm:text-xl/8">
              It looks like your payment was abandoned. You can try again or
              contact support for assistance.
            </p>

            <div className="mt-10 flex items-center justify-center gap-x-6">
              <button
                onClick={async () => {
                  await GenerateLink();
                }}
                className="rounded-md bg-[#55C6EF] px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-[#31a6d1] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                {ViewLoading ? (
                  <div className="w-5 h-5 border-4 border-t-4 border-transparent border-solid rounded-full animate-spin border-t-white"></div>
                ) : (
                  "Try Again"
                )}
              </button>
              <a
                href="tel:17130000"
                className="text-sm font-semibold text-gray-900"
              >
                Contact support <span aria-hidden="true">&rarr;</span>
              </a>
            </div>
          </div>
        </main>
      </>
    );
  } else if (payment && payment.PaymentStatus === "FAILED") {
    return (
      <>
        <main className="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
          <div className="text-center">
            <div className="flex justify-center">
              <img src={Logo} alt="Solidarity Logo" className="h-10 mb-4" />
            </div>

            <h1 className="mt-4 text-balance text-5xl font-semibold tracking-tight text-red-600 sm:text-7xl">
              Payment Failed
            </h1>

            <p className="mt-6 text-pretty text-lg font-medium text-gray-500 sm:text-xl/8">
              Unfortunately, your payment could not be processed. Please try
              again or contact support if the issue persists.
            </p>

            <div className="mt-10 flex items-center justify-center gap-x-6">
              <button
                onClick={async () => {
                  await GenerateLink();
                }}
                className="rounded-md bg-[#55C6EF] px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-[#31a6d1] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                {ViewLoading ? (
                  <div className="w-5 h-5 border-4 border-t-4 border-transparent border-solid rounded-full animate-spin border-t-white"></div>
                ) : (
                  "Try Again"
                )}
              </button>
              <a
                href="tel:17130000"
                className="text-sm font-semibold text-gray-900"
              >
                Contact support <span aria-hidden="true">&rarr;</span>
              </a>
            </div>
          </div>
        </main>
      </>
    );
  } else if (payment && payment.PaymentStatus === "CANCELLED") {
    return (
      <>
        <main className="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
          <div className="text-center">
            <div className="flex justify-center">
              <img src={Logo} alt="Solidarity Logo" className="h-10 mb-4" />
            </div>

            <h1 className="mt-4 text-balance text-5xl font-semibold tracking-tight text-red-600 sm:text-7xl">
              Payment Cancelled
            </h1>

            <p className="mt-6 text-pretty text-lg font-medium text-gray-500 sm:text-xl/8">
              You have cancelled your payment. If this was a mistake, you can
              try again or contact support for assistance.
            </p>

            <div className="mt-10 flex items-center justify-center gap-x-6">
              <button
                onClick={async () => {
                  await GenerateLink();
                }}
                className="rounded-md bg-[#55C6EF] px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-[#31a6d1] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                {ViewLoading ? (
                  <div className="w-5 h-5 border-4 border-t-4 border-transparent border-solid rounded-full animate-spin border-t-white"></div>
                ) : (
                  "Try Again"
                )}
              </button>
              <a
                href="tel:17130000"
                className="text-sm font-semibold text-gray-900"
              >
                Contact support <span aria-hidden="true">&rarr;</span>
              </a>
            </div>
          </div>
        </main>
      </>
    );
  } else if (payment && payment.PaymentStatus === "DECLINED") {
    return (
      <>
        <main className="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
          <div className="text-center">
            <div className="flex justify-center">
              <img src={Logo} alt="Solidarity Logo" className="h-10 mb-4" />
            </div>

            <h1 className="mt-4 text-balance text-5xl font-semibold tracking-tight text-rose-600 sm:text-7xl">
              Payment Declined
            </h1>

            <p className="mt-6 text-pretty text-lg font-medium text-gray-500 sm:text-xl/8">
              Your payment was declined by your bank or card provider. Please
              use a different payment method or contact support for help.
            </p>

            <div className="mt-10 flex items-center justify-center gap-x-6">
              <button
                onClick={async () => {
                  await GenerateLink();
                }}
                className="rounded-md bg-[#55C6EF] px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-[#31a6d1] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                {ViewLoading ? (
                  <div className="w-5 h-5 border-4 border-t-4 border-transparent border-solid rounded-full animate-spin border-t-white"></div>
                ) : (
                  "Try Again"
                )}
              </button>

              <a
                href="tel:17130000"
                className="text-sm font-semibold text-gray-900"
              >
                Contact support <span aria-hidden="true">&rarr;</span>
              </a>
            </div>
          </div>
        </main>
      </>
    );
  }
};

export default PolicyDocs;
